export default __webpack_public_path__ + "static/media/Comp 2_00040.b9e6a5e4.png";